import { Component, ViewChild, ElementRef, Input, SimpleChanges, OnChanges, Output, EventEmitter, OnInit } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexStroke,
  ApexXAxis,
  ApexFill,
  ApexTooltip, NgApexchartsModule,
  ApexGrid
} from 'ng-apexcharts';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { AttendanceService } from 'src/app/shared/services/attendanceservices/attendance.service';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { RouterModule } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

export interface ChartOptions {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
  grid: ApexGrid;
}

@Component({
  selector: 'app-user-detail-count',
  templateUrl: './user-detail-count.component.html',
  styleUrls: ['./user-detail-count.component.css'],
  standalone: true,
  imports: [NgApexchartsModule,LoaderComponent, CommonModule, DecimalPipe, RouterModule],
  providers: [DatePipe]

})
export class UserDetailCountComponent implements OnChanges, OnInit {
  @Input() userData: any;
  @ViewChild('chart') chart!: ChartComponent;
  @ViewChild('employeeCards') employeeCards!: ElementRef;
    @Input() isLoading = true;
 @Input() actionView = false;
  @Output() downloadPDFStart = new EventEmitter<void>();
  @Output() downloadPDFEnd = new EventEmitter<void>();
  public chartOptions!: ChartOptions;
  userSalary: any;
  startdate: any;
  endDate: any;
  attendanceData: any[] = [];
  todayAttendance: any;
  attendanceStatus: any;
  isShortHours = false;
  isAbsent = false;
  isFullDay = false;
  remainleaves: any;
  totalPaidLeaves = 0;
  availedPaidLeaves = 0;
  leaveData: any;
  availablePaidLeaves = 0;
  evaluationData: any;
  latestevaluation: any;
  percentageEvaluation: any;
  evalutaionMonth: any;
  total_evalutaion = 0;
  evaluationStatus: any;
  isWorking = false;
  // isLoading: boolean = true;
   public showSpinner = false;


  constructor(
    private addService: AddService,
    private attendanceService: AttendanceService,
    public datepipe: DatePipe,
    public dashboardService: DashboardService,
  ) {
    // Initial empty chart
    
    this.chartOptions = {
      series: [],
      chart: {
        type: 'bar',
        height: 280,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '50%',
          borderRadius: 6,
          borderRadiusApplication: 'end'
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: [],
        title: { text: 'Days' }
      },
      yaxis: {
        min: 0,
        max: 12,
        tickAmount: 12,
        labels: {
          formatter: (val: number) => Math.floor(val).toString()
        },
        title: { text: 'Hours' }
      },
      stroke: { show: false },
      fill: { opacity: 1 },
      tooltip: {
        custom: ({ dataPointIndex, w }) => {
          const dayData = this.attendanceData[dataPointIndex];
          if (!dayData) return '<div>No data</div>';
          return `
            <div style="padding:5px;">
              <b>Date:</b> ${dayData.date}<br/>
              <b>Check In:</b> ${this.formatTime(dayData.check_in)}<br/>
              <b>Check Out:</b> ${this.formatTime(dayData.check_out)}<br/>
              <b>Total Hours:</b> ${dayData.total_hours ?? 0}
            </div>
          `;
        }
      },
      legend: { show: false },
      grid: {
        show: true,
        borderColor: '#f3f3f3ff',
        strokeDashArray: 0,
        xaxis: { lines: { show: false } },
        yaxis: { lines: { show: true } }
      }
    };
  }

  
  ngOnChanges(changes: SimpleChanges) {
      if (changes['isLoading']) {
        console.log('isLoading changed:', changes['isLoading'].currentValue);
      }
    if (changes['userData']?.currentValue) {
      
      this.getAttendanceData(this.userData?.id);
      this.leaveInfo(this.userData?.id);
      
      this.evaluation(this.userData?.id);
      this.calculatePayroll(this.userData?.id);
    }
  }
  ngOnInit(): void {
  }

  formatTime(time: string | null): string {
    if (!time) return '--:--';
    const [h, m] = time.split(':').map(Number);
    const suffix = h >= 12 ? ' PM' : ' AM';
    const hour12 = ((h + 11) % 12) + 1;
    return `${hour12}:${m.toString().padStart(2, '0')}${suffix}`;
  }

  calculatePayroll(id: any) {
    this.addService.userComingSalary(id).then((value) => {
      this.userSalary = value;
       this.isLoading = false;
    });
  }

  getAttendanceData(id: any) {
    const user_id = id
    this.attendanceService.getUserttendance(user_id).then((value) => {

      this.attendanceData = value?.data?.attendance || [];


      const todayStr = this.datepipe.transform(new Date(), 'yyyy/MM/dd');
      this.todayAttendance = this.attendanceData.find((x: any) => x.date === todayStr);

      if (this.todayAttendance) {


        const worked = Number(this.todayAttendance?.total_hours ?? 0);
        const expected = Number(this.todayAttendance?.usershittime?.total_working_hours ?? 0);
        if (this.todayAttendance.check_in == null && this.todayAttendance.check_out == null) {
          this.attendanceStatus = 'Absent';
          this.isAbsent = true;
        }
        if (worked === 0) {
          this.attendanceStatus = 'Working';
          this.isWorking = true;
        } else if (worked < expected) {
          this.attendanceStatus = 'Short Hrs';
          this.isShortHours = true;
        } else {
          this.attendanceStatus = 'Full Day';
          this.isFullDay = true;
        }
      }

      const categories = this.attendanceData.map(x =>
        new Date(x?.date).getDate().toString()
      );
      const dataWithColors = this.attendanceData.map((x: any) => {
      const hours = x?.total_hours ? Number(x.total_hours) : 0;
      const expectedHours = x?.usershittime?.total_working_hours
        ? Number(x.usershittime.total_working_hours)
        : 0;

      let fillColor = '#F6CECE'; // Red (absent/0 hrs)
      let displayHours = hours;

      if (hours >= expectedHours) {
        fillColor = '#CEEED9'; // Green (full day)
      } else if (hours > 0 && hours < expectedHours) {
        fillColor = '#DBC1E8'; // Purple (short hrs)
      } else if (hours === 0) {
        // Absent case: show a tiny visible bar
        fillColor = '#F6CECE';
        displayHours = expectedHours;
      }

      return {
        x: new Date(x?.date).getDate().toString(),
        y: displayHours,
        fillColor
      };
    });

      // Update chart
     this.chartOptions = {
        ...this.chartOptions,
        series: [
          {
            name: 'Working Hours',
            data: dataWithColors
          }
        ],
        xaxis: {
          ...this.chartOptions.xaxis,
          categories
        }
      };
    });
  }

  leaveInfo(id: any) {
    const user_id = id;
    this.dashboardService.getUserRemainingLeaves(user_id).then((value) => {
      this.leaveData = value.data.data


      this.totalPaidLeaves = 0;
      this.availedPaidLeaves = 0;

      this.leaveData
        .filter((leave: any) => leave.leave_type === 'paid')
        .forEach((leave: any) => {
          this.totalPaidLeaves += Number(leave.assigned_leaves ?? 0);
          this.availedPaidLeaves += Number(leave.leave_count ?? 0);
        });

      this.availablePaidLeaves = this.totalPaidLeaves - this.availedPaidLeaves;
    })
  }


  evaluation(id: any) {
    const user_id = id
    this.dashboardService.getEvaluation(user_id).then((value) => {

      if (value?.success == true) {
        this.evaluationData = value.data.latest;
        this.evaluationStatus = value.data?.status
        this.latestevaluation = this.evaluationData?.pm_points;
        this.percentageEvaluation = value.data.change_percentage;
        this.evalutaionMonth = this.evaluationData?.month_char;
        this.total_evalutaion = 10;
      } else {
        this.latestevaluation = 0;
        this.percentageEvaluation = 0;
        this.evalutaionMonth = "Month";
        this.total_evalutaion = 10;
        this.evaluationStatus = ''
      }


    })

  }

// toDataURL(url: string): Promise<string> {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//     img.crossOrigin = 'Anonymous'; // Important
//     img.src = url;
//     img.onload = () => {
//       const canvas = document.createElement('canvas');
//       canvas.width = img.width;
//       canvas.height = img.height;
//       const ctx = canvas.getContext('2d');
//       ctx?.drawImage(img, 0, 0);
//       resolve(canvas.toDataURL('image/png'));
//     };
//     img.onerror = error => reject(error);
//   });
// }

 async downloadPDF() {
  this.showSpinner = true;

  // Let Angular render the spinner
  setTimeout(async () => {
    const element = this.employeeCards.nativeElement;
    const canvas = await html2canvas(element, { scale: 3, useCORS: true, allowTaint: false });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgProps = pdf.getImageProperties(imgData);
    const imgWidth = pdfWidth * 0.8;
    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

    const x = (pdfWidth - imgWidth) / 2;
    const y = (pdfHeight - imgHeight) / 2;

    pdf.addImage(imgData, 'PNG', x, y, imgWidth, imgHeight);
    pdf.save('employee-card.pdf');

    this.showSpinner = false;
  }, 0);
}






}
